import React, { useState, useRef, useEffect } from "react";
import "../css/style.css";
import { apiCalling,elasticSearchApicall } from "../apiService";
import { elasticLink } from "../config";
import chartImg from '../image/media/botimg.png';
import AWS from "aws-sdk";
// import elasticsearch from "elasticsearch";
import { FiX, FiUser, FiVideo, FiPhoneCall, FiMessageSquare, FiArrowLeftCircle, FiXCircle, FiArrowRight, FiArrowRightCircle, FiSmartphone, FiMail } from "react-icons/fi";
import $ from "jquery";
// import DatePicker from "react-datepicker";
// import moment from "moment";
AWS.config.region = "us-west-1";
const ChatBoat = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState("What can I do for you?");
  const [searchQuery, setSearchQuery] = useState("");
  // const [s3AccessKey, setS3AccessKey] = useState("");
  // const [s3SecretKey, setS3SecretKey] = useState("");
  const [doctorServices, setDoctorServices] = useState([]);
  const [step, setStep] = useState(0);
  let chatBoxRef = useRef(null);
  const [doctorlist, setDoctorlist] = useState([]);
  const [doctorDataCount, setDoctorDataCount] = useState(0);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showAppointmentInput, setShowAppointmentInput] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [backState, setBackState] = useState(0);
  const [contactAsNumber, setContactAsNumber] = useState("");
  const [headerDataLink, setHeaderDataLink] = useState({});
  const urlPath = window.location.origin.toString();
  const [searchCriteriaResults, setSearchCriteriaResults] = useState(true);
  const hospitalData = JSON.parse(
    window.sessionStorage.getItem("footerhospitalData")
  );
  // const [appointmentTime, setAppointmentTime] = useState("");
  // const [appointmentSlot, setAppointmentSlot] = useState([]);
  // const [includeDates, setIncludeDates] = useState([]);
  useEffect(() => {
    initializeChatBot();
    headerLoading()
  }, []);
  const headerLoading = () => {
    const headerDetails = {
      method: "POST",
      body: JSON.stringify({
        functionName: "headerLinksDetails",
        siteId: window.sessionStorage.getItem("siteId"),
      }),
    };

    apiCalling(headerDetails).then((data) => {
      if (data.success === "1") {
        setHeaderDataLink(data.headerLinkContent)
      } else {
        setHeaderDataLink({})
      }
    });
  }
  useEffect(() => {
    if (searchQuery.trim().length > 1) {
      getDoctors(0, 24);
    }
  }, [searchQuery]);

  // useEffect(() => {
  //   if (selectedService) { getCalenderData(); }

  // }, [selectedService]);

  const initializeChatBot = async () => {
    try {
      setLoading(true);
      await getDoctorService();
      // await awsCredentials();
    } catch (err) {
      console.error("Initialization error:", err);
      setError("Failed to initialize chatbot.");
    } finally {
      setLoading(false);
    }
  };
  const handleScroll = () => {
    if (chatBoxRef.current) {
      chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
    }
  };
  const handleChat = (message) => {
    const elm = document.createElement("p");
    elm.textContent = message;
    elm.className = "msg";
    chatBoxRef.current?.appendChild(elm);
    handleScroll();
  };
  const toggleChat = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      setSelectedDoctor(null);
      clearSearch();
      setShowAppointmentInput(false)
      setStep(0);
      setCurrentQuestion("What can I do for you?");
    }
  };
  const getDoctorService = async () => {
    try {
      const apiJson = {
        method: "POST",
        body: JSON.stringify({
          functionName: "groupService",
          siteId: window.sessionStorage.getItem("siteId"),
        }),
      };
      const data = await apiCalling(apiJson);
      if (data.success === "1" && data.service) {
        const services = data.service.map((item) => item.serviceId.toString());
        setDoctorServices(services);
      }
    } catch (err) {
      console.error("Error fetching doctor services:", err);
    }
  };
  // const awsCredentials = async () => {
  //   try {
  //     const apiJson = {
  //       method: "POST",
  //       body: JSON.stringify({
  //         functionName: "imagePath",
  //         siteId: window.sessionStorage.getItem("siteId"),
  //       }),
  //     };
  //     const response = await apiCalling(apiJson);
  //     if (response.success === "1") {
  //       const [config] = response.configPathDetails;
  //       setS3AccessKey(config.AwsCheckAccessKey);
  //       setS3SecretKey(config.s3bucketSecretKey);
  //     }
  //   } catch (err) {
  //     console.error("Error fetching AWS credentials:", err);
  //   }
  // };

  const getDoctors = async (sectionId, hospitalId, type, onlineStatus) => {
    setLoading(true);
    setError(null);
    setSelectedService(type)
    $(".loader").show();
    setBackState(2)
    try {
      const filters = [
        { term: { site_id: window.sessionStorage.getItem("siteId") } },
        { term: { "section_type.keyword": "DOCTORBYHOSPITAL" } },
      ];

      if (onlineStatus) {
        filters.push({ term: { [onlineStatus]: "1" } });
      }
      const apiJson ={
        "index": elasticLink(),
        "offset": 0,
        "max": 100,
        "searchBody": {
          query: {
            bool: {
              filter: {
                bool: {
                  must: filters,
                },
              },
            },
          },
          sort: {
            _script: {
              script: "(doc['_id'].value + 8950696).hashCode()",
              type: "number",
              order: "asc",
            },
          },
        }
    }
    // return
      const response = await elasticSearchApicall(apiJson);
      if (response.success === "1") { 
      try {
        setDoctorlist(response.result.hits.hits);
        setSearchCriteriaResults(response.result.hits.hits.length > 0);
        setDoctorDataCount(response.result.hits.total.value);
        // if (response.length > 0) { 
        //  else {
        //   handleChat("No doctors found matching your criteria. Please try another search.");
        // }
      } catch (err) {
        console.error("Error fetching doctors:", err);
        setSearchCriteriaResults(false);
        setError("Failed to fetch doctor data. Please try again.");
      } finally {
        $(".loader").hide();
        setLoading(false);
      }
      }
    } catch (err) {
      console.error("Error fetching AWS credentials:", err);
    }

  };

  const clearSearch = () => {
    setSearchQuery("");
    setBackState(0)
    setContactAsNumber("")
    setSelectedDoctor(null);
    // setAppointmentTime("")
    // setAppointmentDate(null)
    setDoctorlist([]);
    setDoctorDataCount(0);
    setSelectedDoctor(null);
    handleChat("Search cleared. How else can I assist?");
  };

  const handleDoctorSelection = (doctor) => {
    setSelectedDoctor(doctor);
    setBackState(3)
    handleChat(`Selected Doctor: ${doctor.section_name}`);
    // setSearchQuery("");
    setDoctorlist([]);

    setDoctorServices(doctor);
  };


  const isLoginCheck = () => {
    let flag = true;
    if (!window.sessionStorage.getItem("isLogin")) {
      $("#ForgotPasswordWrap").hide();
      $("#SignupWrap").hide();
      $("#signInWrapDiv").hide();
      flag = false;
    }
    return flag;
  }
  const isLoginValidate = (doctorId, hospitalId, flagOption, bySlot) => {
    setIsOpen(!isOpen);
    if (isLoginCheck() === true) {
      window.sessionStorage.setItem("loginValidate", "book");
      // window.sessionStorage.setItem("AppFlag", "2");
      window.sessionStorage.setItem("appDocId", doctorId);
      window.sessionStorage.setItem("appHosId", hospitalId);
      window.sessionStorage.setItem("flagOption", selectedService);
      // window.sessionStorage.setItem("bySlot", "Yes");
      // window.sessionStorage.setItem("fromBot", "Yes");
      // window.sessionStorage.setItem("selDate", appointmentDate);
      // window.sessionStorage.setItem("selTime", appointmentTime);
      window.location.href = "/patient/bookappointment";
    }
    else {
      window.sessionStorage.setItem("loginValidate", "book");
      // window.sessionStorage.setItem("AppFlag", "2");
      window.sessionStorage.setItem("appDocId", doctorId);
      // window.sessionStorage.setItem("fromBot", "Yes");
      window.sessionStorage.setItem("appHosId", hospitalId);
      window.sessionStorage.setItem("flagOption", selectedService);
      // window.sessionStorage.setItem("selDate", appointmentDate);
      // window.sessionStorage.setItem("selTime", appointmentTime);
      // window.sessionStorage.setItem("bySlot", "Yes");
      $("#ForgotPasswordWrap").hide();
      // window.location.href = "/patient/bookappointment";
      $("#SignupWrap").hide();
      $("#signInWrapDiv").show();
    }
    setIsOpen(!isOpen);
  }
  const isLoginValidateTextChatWithPayment = (
    doctorId,
    hospitalId,
    chatdoctorpanelid,
    messaging_cost
  ) => {
    if (isLoginCheck() === true) {
      window.sessionStorage.setItem("loginValidate", "");
      window.sessionStorage.setItem("appDocId", doctorId);
      window.sessionStorage.setItem("appHosId", hospitalId);
      window.sessionStorage.setItem("flagOption", selectedService);
      window.sessionStorage.setItem("chatDoctorPanelId", chatdoctorpanelid);
      window.sessionStorage.setItem("messaging_cost", messaging_cost);
      // window.sessionStorage.setItem("bySlot", "Yes");
      // window.sessionStorage.setItem("selDate", appointmentDate);
      // window.sessionStorage.setItem("AppFlag", "2");
      // window.sessionStorage.setItem("selTime", appointmentTime);
      // window.sessionStorage.setItem("fromBot", "Yes");
      window.location.href = "/patient/textchatpayment";

    }
    else {
      window.sessionStorage.setItem("loginValidate", "TextChatPay");
      // window.sessionStorage.setItem("AppFlag", "2");
      // window.sessionStorage.setItem("fromBot", "Yes");
      window.sessionStorage.setItem("messaging_cost", messaging_cost);
      window.sessionStorage.setItem("appDocId", doctorId);
      window.sessionStorage.setItem("appHosId", hospitalId);
      window.sessionStorage.setItem("chatDoctorPanelId", chatdoctorpanelid);
      window.sessionStorage.setItem("flagOption", selectedService);
      // window.sessionStorage.setItem("selDate", appointmentDate);
      // window.sessionStorage.setItem("selTime", appointmentTime);
      // window.sessionStorage.setItem("bySlot", "Yes");
      // window.location.href = "/patient/bookappointment";
      $("#ForgotPasswordWrap").hide();
      $("#SignupWrap").hide();
      $("#signInWrapDiv").show();
    }
    setIsOpen(!isOpen);
  }

  // const handleInputChangeSlot = async (date) => {
  //   const newAppDate = moment(date).format("DD/MM/YYYY");
  //   const apiJson = {
  //     method: "POST",
  //     body: JSON.stringify({
  //       functionName: "appointmentSlot",
  //       appoinmentType: selectedService,
  //       doctorId: doctorServices.section_id,
  //       hospitalId: doctorServices.hospital_id,
  //       appointmentDate: newAppDate,
  //     }),
  //   };
  //   const data = await apiCalling(apiJson);
  //   if (data.isExist === "true") {
  //     setAppointmentSlot(data.slotValUtc);
  //   } else {
  //     alert("Doctor is not available at selected date. Please select another time slot.");
  //     setAppointmentSlot([]);
  //   }
  // };

  // const handleChangeDate = (date) => {
  //   setAppointmentDate(date);
  //   handleInputChangeSlot(date);
  // };

  // const handleInputChangeTime = (event) => {
  //   setAppointmentTime(event.target.value);
  // };

  // const getCalenderData = async () => {
  //   const apiJson = {
  //     method: "POST",
  //     body: JSON.stringify({
  //       functionName: "slotAvailableDays",
  //       siteId: window.sessionStorage.getItem("siteId"),
  //       doctorId: window.sessionStorage.getItem("appDocId"),
  //       hospitalId: window.sessionStorage.getItem("appHosId"),
  //       appoinmentType: selectedService,
  //     }),
  //   };
  //   const data = await apiCalling(apiJson);
  //   if (data.availableSlot) {
  //     const dateset = data.availableSlot.map(date => new Date(date));
  //     console.log("🚀 ~ getCalenderData ~ dateset:", dateset)
  //     setIncludeDates(dateset);
  //   } else {
  //     setIncludeDates([]);
  //   }
  // };
  useEffect(() => {
    if (!showAppointmentInput && !contactAsNumber) {
      setBackState(0);
    }
  }, [showAppointmentInput, contactAsNumber]);
  const handleArrowLeftClick = (steps) => {
    setContactAsNumber("")
    if ((backState - steps) === 0) {
      setBackState(1);
      setShowAppointmentInput(false);
    } else if ((backState - steps) === 1) {
      setBackState(1);
      setShowAppointmentInput(false);
      setSelectedDoctor(null);
      setDoctorDataCount(0);
      setDoctorlist([]);
      if (chatBoxRef.current) {
        chatBoxRef.current.innerHTML = ""; // Clear chatbox messages
      }
    } else if ((backState - steps) === 2) {
      setBackState(2);
      setShowAppointmentInput(true);
      setSelectedDoctor(null);
      setDoctorDataCount(0);
      setDoctorlist([]);
      if (chatBoxRef.current) {
        chatBoxRef.current.innerHTML = ""; // Clear chatbox messages
      }
    } else if ((backState - steps) === 3) {
      setBackState(2);
      setDoctorlist([]);
      setSelectedDoctor(null);
      if (chatBoxRef.current) {
        chatBoxRef.current.innerHTML = ""; // Clear chatbox messages
      }
    }
  };
  const chatmessageClickValidate = (
    doctorId,
    hospitalId,
    chatDoctorPanelId,
    textChatPrice
  ) => {
    $(".loader").show();
    const jsonData = {
      method: "POST",
      body: JSON.stringify({
        functionName: "messageChatFree",
        chatDoctorPanelId: chatDoctorPanelId,
        memberId: window.sessionStorage.getItem("userId"),
        doctorId: doctorId,
        hospitalId: hospitalId,
      }),
    };
    // console.log(jsonData.body);
    apiCalling(jsonData).then((data) => {
      if (data.success === "1") {
        window.sessionStorage.setItem("API_KEY", data.API_KEY);
        window.sessionStorage.setItem("sessionId", data.sessionId);
        window.sessionStorage.setItem("token", data.token);
        window.sessionStorage.setItem("appDocId", doctorId);
        window.sessionStorage.setItem("appHosId", hospitalId);
        window.sessionStorage.setItem("chatDoctorPanelId", data.chatGroupId); //chatDoctorPanelId);
        window.location.href = "/chat/chatmessage";
      } else {
        chatmessageClickValidate(
          doctorId,
          hospitalId,
          chatDoctorPanelId,
          textChatPrice
        );
        //console.log("Error: API : messageChatFree");
      }
    });
  }
  const chatmessageClick = (doctorId, hospitalId, chatDoctorPanelId, textChatPrice) => {
    if (isLoginCheck() === true) {
      chatmessageClickValidate(
        doctorId,
        hospitalId,
        chatDoctorPanelId,
        textChatPrice
      );
    } else {
      window.sessionStorage.setItem("loginValidate", "TextChatFree");
      window.sessionStorage.setItem("appDocId", doctorId);
      window.sessionStorage.setItem("appHosId", hospitalId);
      window.sessionStorage.setItem("chatDoctorPanelId", chatDoctorPanelId);
      $("#ForgotPasswordWrap").hide();
      $("#SignupWrap").hide();
      $("#signInWrapDiv").show();
    }
    setIsOpen(!isOpen);
  }
  const changeService = (section_id, hospital_id, service,
  ) => {
    setSelectedService(service)
    if (service === "m") {
      if (doctorServices.messaging_cost > 0) {
        isLoginValidateTextChatWithPayment(
          doctorServices.section_id,
          doctorServices.hospital_id,
          doctorServices.chatdoctorpanelid,
          doctorServices.messaging_cost
        );
      } else {
        chatmessageClick(doctorServices.section_id,
          doctorServices.hospital_id,
          doctorServices.chatdoctorpanelid,
          doctorServices.messaging_cost)
      }
    } else {
      isLoginValidate(doctorServices.section_id,
        doctorServices.hospital_id,
        selectedService,
        "No")
    }
  }
  const contactAs = (contactNumber) => {
    setBackState(1);
    setContactAsNumber(contactNumber)
    // window.location.href = `${urlPath}#footerMain`;
  };

  return (
    <div className="chatbot-parent">
      <div className="chatbot-desc">
        {/* <h1 className="chatbot-text">Medical Chatbot</h1> */}
        {!isOpen ?
          <img
            onClick={toggleChat}
            title="Medical Chatbot"
            src={chartImg}
            alt="Chatbot Icon"
            width={50}
            height={50}
            className="img-fluid chat-box-icon chat-position"
          /> :
          <div className="chatbot-close  chat-position" onClick={toggleChat}>
            <FiX />
          </div>}
      </div>

      {isOpen && (
        <div className="chatbot-window">
          <div className="chatbot-header">
            {backState ?
              <FiArrowLeftCircle onClick={() => handleArrowLeftClick(1)} className="back-button" /> : ""}
            {/* <span className="">Medical Chatbot</span> */}
            <FiXCircle onClick={toggleChat} className="ml-auto" />
          </div>
          {!showAppointmentInput && !contactAsNumber ?
            <div className="welcome-message">
              <h2>Welcome to {hospitalData[0]?.hospitalName}</h2>
              <h3>How Can We Assist You?</h3>
              <div className="welcome-btns">
                <button onClick={() => {
                  setShowAppointmentInput(true);
                  setBackState(1);
                }}>Book Appointment</button>
                <button onClick={() => {
                  window.location.href = '/HealthInfo';
                }}>Blog</button>
                {window.sessionStorage.getItem("google_review_link") ? (
                  <button onClick={() => {
                    setIsOpen(!isOpen);
                    const googleReviewLink = window.sessionStorage.getItem("google_review_link");
                    window.open(googleReviewLink, '_blank');
                  }}>
                    Reviews
                  </button>
                ) : ""}

                {hospitalData?.map((obj) => {
                  let contactNumber = obj.phone;
                  return contactNumber ? (
                    <button onClick={() => contactAs(contactNumber)}>Contact Us</button>
                  ) : null;
                })}

                {headerDataLink.length &&
                  headerDataLink
                    ?.filter((a) => {
                      return a.isActive === true;
                    })
                    .map((headerDeatils) => {
                      return (
                        headerDeatils?.url?.split("-")[0] === "faq" ?
                          <button onClick={() => window.location.href = `${urlPath}/${headerDeatils.url}`} key={headerDeatils.url}>
                            {headerDeatils.headerlinkName}
                          </button> : null
                      );
                    })}

              </div>
            </div> : ""}


          {contactAsNumber && <div key={contactAsNumber} className="welcome-message">
            {window.sessionStorage.getItem("contact_emailId") != "" || contactAsNumber ? (
              <>
                <h2>Find As Here</h2>
                {contactAsNumber ?
                  <span className="searchServiceIcon" title="Click To Call">
                    <FiSmartphone />
                    <div className="searchServic-text">
                      <a href={`tel:${contactAsNumber}`}> {contactAsNumber}</a>
                    </div>
                  </span> : ""}
                {window.sessionStorage.getItem("contact_emailId") != "" ?
                  <span className="searchServiceIcon" title="Click To Mail">
                    <FiMail />
                    <div className="searchServic-text">
                      <a href={`mailto:${window.sessionStorage.getItem("contact_emailId")}`}>
                        {window.sessionStorage.getItem("contact_emailId")}
                      </a>
                    </div>
                  </span>
                  : ""}
              </>
            ) : (
              ""
            )}
          </div>}



          {!selectedDoctor && showAppointmentInput ?
            <div className="welcome-message">
              {showAppointmentInput && !selectedDoctor ?
                <>
                  <span
                    onClick={() => getDoctors(doctorServices.section_id, doctorServices.hospital_id, "p", "ishosonline")}
                    title="Book Appointment"
                    className="searchServiceIcon"
                  >
                    <FiUser />  Inperson Appoinment
                    <FiArrowRight className="ml-auto" />
                  </span>

                  <span
                    title="Video Chat"
                    onClick={() => getDoctors(doctorServices.section_id, doctorServices.hospital_id, "v", "is_video_enabled")}
                    className="searchServiceIcon"
                  >
                    <FiVideo /> Video Appoinment
                    <FiArrowRight className="ml-auto" />
                  </span>

                  <span
                    title="Call A Doctor"
                    onClick={() => getDoctors(doctorServices.section_id, doctorServices.hospital_id, "c", "is_call_enabled")}
                    className="searchServiceIcon"
                  >
                    <FiPhoneCall /> Audio Call
                    <FiArrowRight className="ml-auto" />
                  </span>

                  <span
                    onClick={() => getDoctors(doctorServices.section_id, doctorServices.hospital_id, "m", "is_chat_enabled")}
                    title="Doctor Chat"
                    className="searchServiceIcon"
                  >
                    <FiMessageSquare /> Text Chat
                    <FiArrowRight className="ml-auto" />
                  </span>
                </> : ""}
              {!searchCriteriaResults && <p>No doctors available for the criteria.</p>}
              {(selectedDoctor === null && doctorlist.length > 0 && showAppointmentInput) && (
                <div className="search-results-dropdown">
                  {doctorlist.map((data) => {
                    const doc = data._source;
                    return (
                      <div
                        key={doc.section_id}
                        className="search-result-item"
                        title="Click To Select"
                        onClick={() => handleDoctorSelection(doc)}
                      >
                        {doc.section_name} - {doc.sub_section_name}
                      </div>
                    );
                  })}

                </div>
              )}
            </div> : ""}
          {doctorServices && selectedDoctor ?
            <div className="chatbox-select-div">
              {doctorServices.ishosonline === "1" && selectedDoctor ? (
                <span
                  title="Inperson "
                  onClick={(e) =>
                    changeService(
                      doctorServices.section_id,
                      doctorServices.hospital_id,
                      "p",
                      "No"
                    )}
                  className={`searchServiceIcon ${selectedService === "p" ? "text-danger" : ""}`}
                >
                  <FiUser />
                  Inperson | <span className="search-bold"> {parseFloat(doctorServices.consultation_price).toFixed(
                    2
                  ) !== "0.00"
                    ? "₹ " +
                    parseFloat(doctorServices.consultation_price).toFixed(2)
                    : "Free"}
                  </span>
                  <FiArrowRightCircle className="ml-auto"
                  //  onClick={(e) => isLoginValidate(doctorServices.section_id,
                  //   doctorServices.hospital_id,
                  //   selectedService,
                  //   "No")} 
                  />
                </span>
              ) : (
                ""
              )}


              {doctorServices.is_video_enabled === "1" && selectedDoctor ? (
                <span
                  title="Video Chat"
                  onClick={(e) =>
                    changeService(

                      doctorServices.section_id,
                      doctorServices.hospital_id,
                      "v",
                      "No"
                    )}
                  className={`searchServiceIcon ${selectedService === "v" ? "text-danger" : ""}`}
                >
                  {/* <img src={video} alt="" /> */}
                  <FiVideo />
                  Video | <span className="search-bold"> {parseFloat(doctorServices.rate_per_session).toFixed(
                    2
                  ) !== "0.00"
                    ? "₹ " +
                    parseFloat(doctorServices.rate_per_session).toFixed(2)
                    : "Free"}
                  </span>
                  <FiArrowRightCircle className="ml-auto"
                  //  onClick={(e) => isLoginValidate(doctorServices.section_id,
                  //   doctorServices.hospital_id,
                  //   selectedService,
                  //   "No")}
                  />
                </span>
              ) : (
                ""
              )}
              {doctorServices.is_call_enabled === "1" && selectedDoctor ? (
                <span
                  title="Call A Doctor"
                  onClick={(e) =>
                    changeService(

                      doctorServices.section_id,
                      doctorServices.hospital_id,
                      "c",
                      "No"
                    )}
                  className={`searchServiceIcon ${selectedService === "c" ? "text-danger" : ""}`}
                >
                  {/* <img src={call} alt="" /> */}
                  <FiPhoneCall />
                  Audio  | <span className="search-bold"> {parseFloat(doctorServices.phone_consult_price).toFixed(2) !=
                    "0.00"
                    ? "₹ " +
                    parseFloat(doctorServices.phone_consult_price).toFixed(2)
                    : "Free"}
                  </span>
                  <FiArrowRightCircle className="ml-auto"
                  //  onClick={(e) => isLoginValidate(doctorServices.section_id,
                  //   doctorServices.hospital_id,
                  //   selectedService,
                  //   "No")}
                  />
                </span>
              ) : (
                ""
              )}
              {doctorServices.is_chat_enabled === "1" && selectedDoctor ? (
                <span
                  onClick={(e) =>
                    changeService(
                      doctorServices.section_id,
                      doctorServices.hospital_id,
                      "m",
                      "No"
                    )}
                  title="Doctor Chat"
                  className={`searchServiceIcon ${selectedService === "m" ? "text-danger" : ""}`}
                >
                  {/* <img src={chat} alt="" /> */}
                  <FiMessageSquare />
                  Text Chat |  <span className="search-bold">{parseFloat(doctorServices.messaging_cost).toFixed(2) !=
                    "0.00"
                    ? "₹ " +
                    parseFloat(doctorServices.messaging_cost).toFixed(2)
                    : "Free"}
                  </span>
                  <FiArrowRightCircle className="ml-auto" onClick={(e) => {

                  }} />
                </span>
              ) : (
                ""
              )}

              {/* {doctorServices && selectedDoctor ? (
            <div className="row">
              <div className="row-margin col-sm-6">
                <label className="col-sm-12 label-text" style={{ fontSize: "15px" }}>
                  Appointment Date <span className="star-red">*</span>
                </label>
              
                <div className="col-sm-12">
                  <DatePicker
                    placeholderText="Appointment Date"
                    selected={appointmentDate}
                    onChange={handleChangeDate}
                    minDate={new Date()}
                    dateFormat="dd/MM/yyyy"
                    includeDates={includeDates}
                    className="input-design"
                  />
                </div>
              </div>

              <div className="row-margin col-sm-6">
                <label className="col-sm-12 label-text" style={{ fontSize: "15px" }}>
                  Appointment Time <span className="star-red">*</span>
                </label>
                <div className="col-sm-12">
                  <select
                    id="newSlot"
                    name="mm"
                    className="input-design newSlot selecttime"
                    value={appointmentTime}
                    onChange={handleInputChangeTime}
                  >
                    <option value="">- - Select Slot - -</option>
                    {appointmentSlot.map((obj, index) => {
                      const tempDate = moment(obj).format("hh:mm A");
                      return (
                        <option key={index} value={tempDate}>{tempDate}</option>
                      );
                    })}
                  </select>
                </div>
              </div>

            </div>
          ) : ""} */}
              {/* {selectedDoctor ?
              <button
                onClick={(e) => isLoginValidate(doctorServices.section_id,
                  doctorServices.hospital_id,
                  selectedService,
                  "No")}
                // onClick={() => goToBookAppoinmentPage(doctorServices.section_id, doctorServices.hospital_id, "p", "ishosonline")}
                title="Book Appointment"
                className="cancel_search"
              >
                Continue
              </button> : ""} */}

            </div> : ""}
          {selectedDoctor ?
            <div className="chatbot-messages" key={selectedDoctor} >
              Selected Doctor :{selectedDoctor.section_name}
            </div> : ""}
          {/* <div className="chatbot-footer"> */}
          {/* {(showAppointmentInput && !selectedDoctor) ?
              <input
                type="text"
                placeholder="Search specialization"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="chatbot-search"
              /> : ""} */}
          {error && <p className="error-message">{error}</p>}
          {/* <span>Powered by Xilli</span> */}
          {/* </div> */}
        </div>
      )}
    </div>
  );
};

export default ChatBoat;
